import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-display-video',
  templateUrl: './display-video.component.html',
  styleUrls: ['./display-video.component.scss']
})
export class DisplayVideoComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public videoId: string) {
  }

  ngOnInit(): void {
  }

}
